/**
 * Created by allen
 */
import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import LA from 'react-loadable';

// 文件分片处理， 主要用到 react-loadable, build 的时候会生成 多个 chunk.js
// npm i babel-plugin-syntax-dynamic-import
// babel 的 plugins 加 plugins
// npm i react-loadable
function MyLoadingComponent({ error, pastDelay }) {
        if (error) {
                return <div>Error!</div>; // 加载错误时的提示模块
        } else if (pastDelay) {
                return <div>Loading...</div>;
        } else {
                return null; // 加载时间短于pastDelay（默认200ms）则不显示Loading动画
        }
}

const Dashboard =  LA({loader: () => import('../components/dashboard/Dashboard'),loading:MyLoadingComponent,});

//sysmanager
const UserGroupList =  LA({loader: () => import('../components/sysmanager/usergroup/UserGroupList'),loading:MyLoadingComponent,});
const UserList = LA({loader: () => import('../components/sysmanager/UserList'),loading:MyLoadingComponent,});
const AreaList = LA({loader: () => import('../components/sysmanager/area/AreaList'),loading:MyLoadingComponent,})
const configSetting = LA({loader: () => import('../components/sysmanager/config/configSetting'),loading:MyLoadingComponent,})

//import AreaList from '../components/sysmanager/AreaList';
//import SettingList from '../components/sysmanager/SettingList';
//devmanager
const DevList = LA({loader: () => import('../components/devmanager/DevList'),loading:MyLoadingComponent,})
const TaskList = LA({loader: () => import('../components/devmanager/task/TaskList'),loading:MyLoadingComponent,})
const ResList = LA({loader: () => import('../components/devmanager/res/ResList'),loading:MyLoadingComponent,})
const AlarmList = LA({loader: () => import('../components/devmanager/alarm/AlarmList'),loading:MyLoadingComponent,})
const ReplaceList = LA({loader: () => import('../components/devmanager/replace/ReplaceList'),loading:MyLoadingComponent,})
const TaskHistoryList = LA({loader: () => import('../components/devmanager/taskhistory/TaskHistoryList'),loading:MyLoadingComponent,})
const ProblemList = LA({loader: () => import('../components/devmanager/problem/ProblemList'),loading:MyLoadingComponent,})
const LoggerList = LA({loader: () => import('../components/devmanager/logger/LoggerList'),loading:MyLoadingComponent,})
const PowerList = LA({loader: () => import('../components/devmanager/power/PowerList'),loading:MyLoadingComponent,})
const PmodelList = LA({loader: () => import('../components/devmanager/pmodel/PmodelList'),loading:MyLoadingComponent,})

const ProjPowerList = LA({loader: () => import('../components/projectmanager/powersetting/powerList'),loading:MyLoadingComponent,})
const ProjOnceGearList = LA({loader: () => import('../components/projectmanager/oncegearsetting/OnecGearList'),loading:MyLoadingComponent,})
const ShareList = LA({loader: () => import('../components/sharemanager/share/shareList'),loading:MyLoadingComponent,})
//company
const CompanyList = LA({loader: () => import('../components/enterprise/CompanyList'),loading:MyLoadingComponent,})
//agent
const AgentList = LA({loader: () => import('../components/agentmanager/agent/AgentList'),loading:MyLoadingComponent,})
//project
const ProjectList = LA({loader: () => import('../components/projectmanager/project/ProjectList'),loading:MyLoadingComponent,})
const ProActiveUserList = LA({loader: () => import('../components/projectmanager/proActiveUser/proActiveUserList'),loading:MyLoadingComponent,})
const PrivateUserList = LA({loader: () => import('../components/projectmanager/privateuser/PrivateUserList'),loading:MyLoadingComponent,})
const ProjectReportList = LA({loader: () => import('../components/reportmanager/project/ProjectReportList'),loading:MyLoadingComponent,})
const AreaStatistics = LA({loader: () => import('../components/projectmanager/areaStatistics/AreaStatistics'),loading:MyLoadingComponent,})



const BankTransferInfoList = LA({loader: () => import('../components/bankmanager/info/BankTransferInfoList'),loading:MyLoadingComponent,})
const BankTransferHistoryList = LA({loader: () => import('../components/bankmanager/history/BankTransferHistoryList'),loading:MyLoadingComponent,})
const BankProjectList = LA({loader: () => import('../components/bankmanager/project/BandProjectList'),loading:MyLoadingComponent,})
const BankOrderList = LA({loader: () => import('../components/bankmanager/order/BankOrderList'),loading:MyLoadingComponent,})
const RechargeList = LA({loader: () => import('../components/bankmanager/recharge/RechargeList'),loading:MyLoadingComponent,})

const ProjRuleList = LA({loader: () => import('../components/rulemanager/projrule/ProjRuleList'),loading:MyLoadingComponent,})
const OrdingList = LA({loader: () => import('../components/ordering/order/orderingList'),loading:MyLoadingComponent,})
const RshareList = LA({loader: () => import('../components/bankmanager/rshare/RshareList'),loading:MyLoadingComponent,})

const AppVersion = LA({loader: () => import('../components/sysmanager/appversion/AppVersion'),loading:MyLoadingComponent,})

const AlarmTypeList = LA({loader: () => import('../components/devmanager/alarmtype/AlarmTypeList'),loading:MyLoadingComponent,})
const AlarmNameList = LA({loader: () => import('../components/devmanager/alarmname/AlarmNameList'),loading:MyLoadingComponent,})
const AlarmNotifyList = LA({loader: () => import('../components/devmanager/alarmnotify/AlarmNotifyList'),loading:MyLoadingComponent,})
const ComboProjectList = LA({loader: () => import('../components/projectmanager/combo/ComboList'),loading:MyLoadingComponent,})
const ComboOrderList = LA({loader: () => import('../components/bankmanager/combo/ComboOrderList'),loading:MyLoadingComponent,})

const AppUserList = LA({loader: () => import('../components/platformmanager/appuser/AppUserList'),loading:MyLoadingComponent,})
const EcardList = LA({loader: () => import('../components/platformmanager/ecard/EcardList'),loading:MyLoadingComponent,})
const EcardLimitList = LA({loader: () => import('../components/platformmanager/cardlimit/CardLimitList'),loading:MyLoadingComponent,})
const OrderOtherList = LA({loader: () => import('../components/platformmanager/orderother/OrderOtherList'),loading:MyLoadingComponent,})

const ImUserList = LA({loader: () => import('../components/platformmanager/imuser/ImUserList'),loading:MyLoadingComponent,})
const ImResultList = LA({loader: () => import('../components/platformmanager/imresult/ImResultList'),loading:MyLoadingComponent,})
const ImHistoryList = LA({loader: () => import('../components/platformmanager/imhistory/ImHistoryList'),loading:MyLoadingComponent,})
const RightList = LA({loader: () => import('../components/platformmanager/right/RightList'),loading:MyLoadingComponent,})
const ProfitList = LA({loader: () => import('../components/projectmanager/profit/ProfitList'),loading:MyLoadingComponent,})
const UpgTasklList = LA({loader: () => import('../components/devmanager/upgtask/UpgTaskList'),loading:MyLoadingComponent,})
const AlarmCountList = LA({loader: () => import('../components/devmanager/alarmcount/AlarmCountList'),loading:MyLoadingComponent,})
const DiscountList = LA({loader: () => import('../components/projectmanager/discount/DiscountList'),loading:MyLoadingComponent,})
const VuserList = LA({loader: () => import('../components/usercenter/vuser/VuserList'),loading:MyLoadingComponent,})
const VuserChargeList = LA({loader: () => import('../components/bankmanager/vusercharge/ChargeList'),loading:MyLoadingComponent,})
const VuserRefundList = LA({loader: () => import('../components/bankmanager/vuserrefund/RefundList'),loading:MyLoadingComponent,})
const CuserList = LA({loader: () => import('../components/usercenter/user/CuserList'),loading:MyLoadingComponent,})
const RefundList = LA({loader: () => import('../components/usercenter/refund/RefundList'),loading:MyLoadingComponent,})
const CompensateList = LA({loader: () => import('../components/usercenter/compensate/CompensateList'),loading:MyLoadingComponent,})



export default class CRouter extends Component {
    requireAuth = (permission, component) => {
        const { auth } = this.props;
        const { permissions } = auth.data;
        // const { auth } = store.getState().httpData;
        if (!permissions || !permissions.includes(permission)) return <Redirect to={'404'} />;
        return component;
    };
    render() {
        return (
            <Switch>
                <Route exact path="/app/dashboard/index" component={Dashboard} />

                <Route exact path="/app/sysmanager/uglist" component={UserGroupList} />
                <Route exact path="/app/sysmanager/user" component={UserList} />
                <Route exact path="/app/sysmanager/area" component={AreaList} />
                <Route exact path="/app/sysmanager/setting" component={configSetting} />

                <Route exact path="/app/devmanager/devlist" component={DevList} />
                <Route exact path="/app/devmanager/hitch" component={AlarmList} />
                <Route exact path="/app/devmanager/replacehistory" component={ReplaceList} />
                <Route exact path="/app/devmanager/resource" component={ResList} />
                <Route exact path="/app/devmanager/task" component={TaskList} />
                <Route exact path="/app/devmanager/taskhistory" component={TaskHistoryList} />
                <Route exact path="/app/devmanager/problem" component={ProblemList} />
                <Route exact path="/app/devmanager/logger" component={LoggerList} />
                <Route exact path="/app/devmanager/power" component={PowerList} />
                <Route exact path="/app/devmanager/hdd" component={PmodelList} />
                <Route exact path="/app/devmanager/upgtask" component={UpgTasklList} />
                <Route exact path="/app/devmanager/alarmcount" component={AlarmCountList} />

                <Route exact path="/app/company" component={CompanyList} />
                <Route exact path="/app/proj/share" component={ShareList} />

                <Route exact path="/app/agent" component={AgentList} />
                <Route exact path="/app/proj/projpower" component={ProjPowerList} />
                <Route exact path="/app/proj/projoncegear" component={ProjOnceGearList} />
                <Route exact path="/app/proj/project" component={ProjectList} />
                <Route exact path="/app/proj/active_user" component={ProActiveUserList} />
                <Route exact path="/app/proj/area_statistics" component={AreaStatistics} />
                <Route exact path="/app/proj/discount" component={DiscountList} />
                
                <Route exact path="/app/proj/statistics" component={ProjectReportList} />
                <Route exact path="/app/proj/profit" component={ProfitList} />

                <Route exact path="/app/privateuser" component={PrivateUserList} />



                <Route exact path="/app/banktransfer/info" component={BankTransferInfoList} />
                <Route exact path="/app/banktransfer/history" component={BankTransferHistoryList} />
                <Route exact path="/app/banktransfer/project" component={BankProjectList} />
                <Route exact path="/app/banktransfer/orderlist" component={BankOrderList} />
                <Route exact path="/app/banktransfer/rechargelist" component={RechargeList} />
                <Route exact path="/app/banktransfer/rechargeshare" component={RshareList} />
                <Route exact path="/app/banktransfer/comboorder" component={ComboOrderList} />

                <Route exact path="/app/proj/projrule" component={ProjRuleList} />

                <Route exact path="/app/ordering" component={OrdingList} />
                <Route exact path="/app/appversion" component={AppVersion} />
                <Route exact path="/app/alarm/type" component={AlarmTypeList} />
                <Route exact path="/app/alarm/item" component={AlarmNameList} />
                <Route exact path="/app/alarm/message" component={AlarmNotifyList} />
                <Route exact path="/app/proj/projcomboo" component={ComboProjectList} />

                <Route exact path="/app/appuser" component={AppUserList} />
                <Route exact path="/app/ecard/ecardtable" component={EcardList} />
                <Route exact path="/app/ecard/cardlimit" component={EcardLimitList} />
                <Route exact path="/app/orderinfo" component={OrderOtherList} />

                <Route exact path="/app/installmanager/user" component={ImUserList} />
                <Route exact path="/app/installmanager/report" component={ImResultList} />
                <Route exact path="/app/installmanager/history" component={ImHistoryList} />
                <Route exact path="/app/rightmanager" component={RightList} />

                <Route exact path="/app/usercenter/vuser" component={VuserList} />
                <Route exact path="/app/usercenter/user" component={CuserList} />
                <Route exact path="/app/usercenter/compensate" component={CompensateList} />

                <Route exact path="/app/banktransfer/vusercharge" component={VuserChargeList} />
                <Route exact path="/app/banktransfer/vuserrefund" component={VuserRefundList} />
                <Route exact path="/app/usercenter/refund" component={RefundList} />

                <Route render={() => <Redirect to="/404" />} />
            </Switch>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/index.js